import { useQuery } from "@tanstack/react-query";
import { TreasuryClient, getActiveClient } from "./client";

export const STATUS_COLOR = {
  pending: "text-current",
  PENDING: "text-current",
  received: "text-warn",
  RECEIVED: "text-warn",
  paid: "text-success",
  PAID: "text-success",
  duplicate: "text-disabled",
  DUPLICATE: "text-disabled",
  invalid: "text-error",
  INVALID: "text-error"
}

export function useSellRequest(id) {
  let treasuryClient = TreasuryClient.from(getActiveClient());
  return useQuery({
    queryKey: ["GET", treasuryClient.url, "/sell", `/${id}`],
    queryFn: async function getSellRequestQueryFn() {
      return treasuryClient.getSellRequest(id);
    },
    refetchOnWindowFocus: "always",
    refetchOnMount: "always",
    refetchOnReconnect: "always",
  });

}

export function useSellRequestList() {
  let treasuryClient = TreasuryClient.from(getActiveClient());
  return useQuery({
    queryKey: ["GET", treasuryClient.url, "/sell"],
    queryFn: async function getSellRequestListQueryFn() {
      return treasuryClient.getSellRequest();
    },
    refetchOnWindowFocus: "always",
    refetchOnMount: "always",
    refetchOnReconnect: "always",
  });

}